/** @typedef {import('./PlayerSettings.types').VHPlayerConfig} VHPlayerConfig */

/**@type {VHPlayerConfig} */
export const VoiceFocusedConfig = {
  inputArea: 'none',
  vhPlayerOverlay: 'call',
  conversationControl: 'internal',
};
